// import { mouseEvent } from "../common/mouse_event";
import BookItem from "../common/bookItem";
//等待中
export default class Sticker extends BookItem {
    constructor(el, target) {
        super(el, target);
        // mouseEvent.add_mouse_event(this);
        this.target.gotoAndStop(0);
        this.objX = this.target.scaleX;
        this.objY = this.target.scaleY;

        this.whiteTriangle = null;
        //這是一個變形的白色三角形
        this.whiteTriangle = this.target.getChildByName("sisi");

        if (this.whiteTriangle.stickerScaleX == undefined) {
            // console.log("undefined進去");
            this.whiteTriangle.stickerScaleX = this.whiteTriangle.stickerScaleX || 1;
            this.whiteTriangle.stickerScaleY = this.whiteTriangle.stickerScaleY || 1;

            //在不同貼紙大小下把白色三角形變成初始貼紙大小時的比例
            this.whiteTriangle.scaleX /= this.objX;
            this.whiteTriangle.scaleY /= this.objY;

            //歸零
            this.whiteTriangle.regX = 0;
            this.whiteTriangle.regY = 0;
            this.whiteTriangle.x = 0;
            this.whiteTriangle.y = 0;
        }
        this.add_mouse_event();
    }

    init() {
        this.whiteTriangle.visible = true;
        this.target.mouseEnabled = true;
    }

    trigger() {
        self = this;
        self.target.gotoAndStop(0);
        this.whiteTriangle.visible = false;
        if (!self.itemControl.loader.antialiasingMovieClips.includes(self.target)) {
            self.itemControl.loader.antialiasingMovieClips.push(self.target);
        }

        self.target.play();
        self.target.loop = 0;

        //不能點了所以關觸碰碰
        self.target.mouseEnabled = false;
    }

    add_mouse_event() {
        this.target.mouseChildren = false;
        this.target.removeAllEventListeners();
        this.target.addEventListener("click", () => {
            this.trigger();
        });
    }
}